import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15280a90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-5 pb-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(`w-full grid grid-cols-8`)
}
const _hoisted_5 = { class: "px-2 py-3 my-auto text-center col-span-2" }
const _hoisted_6 = { class: "px-2 py-3 my-auto text-center flex items-center justify-center" }
const _hoisted_7 = { class: "px-2 py-3 my-auto text-center col-span-2" }
const _hoisted_8 = { class: "px-2 py-3 my-auto text-center col-span-3" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "px-3 py-3",
  style: {"height":"400px"}
}
const _hoisted_11 = { class: "w-full flex items-center justify-center pb-3" }
const _hoisted_12 = {
  key: 1,
  class: "p-3"
}
const _hoisted_13 = {
  key: 2,
  class: "flex justify-center items-center",
  style: {"height":"120px"}
}
const _hoisted_14 = {
  key: 3,
  class: "p-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HistoryListHeader = _resolveComponent("HistoryListHeader")!
  const _component_JudgeBadge = _resolveComponent("JudgeBadge")!
  const _component_MonacoEditorRead = _resolveComponent("MonacoEditorRead")!
  const _component_IconTextButton = _resolveComponent("IconTextButton")!
  const _component_NestedElement = _resolveComponent("NestedElement")!
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!
  const _component_ButtonPanel = _resolveComponent("ButtonPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ButtonPanel, {
      buttonIcon: 'refresh',
      click: _ctx.refresh,
      icon: "history",
      title: `${_ctx.$t(`message.submissionHistory`)}`
    }, {
      default: _withCtx(() => [
        (_ctx.sortedHistoryList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_HistoryListHeader),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedHistoryList, (history) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: history.judgeId
                }, [
                  (_ctx.hasDataInExpandedList(history.judgeId).value && _ctx.hasDataInLoadingList(history.judgeId).value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_NestedElement, {
                          isSummaryExpanded: _ctx.historyExpandedList[history.judgeId],
                          loading: _ctx.historyLoadingList[history.judgeId],
                          onClickSummary: ($event: any) => (_ctx.clickSummary(history.judgeId))
                        }, {
                          labels: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, _toDisplayString(history.judgeId), 1),
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_JudgeBadge, {
                                  status: history.status
                                }, null, 8, ["status"])
                              ]),
                              _createElementVNode("div", _hoisted_7, _toDisplayString(history.programLanguage), 1),
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.timestampToDate(Number(history.submissionDate))), 1)
                            ])
                          ]),
                          body: _withCtx(() => [
                            (_ctx.historySourceCodeList[history.judgeId])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_component_MonacoEditorRead, {
                                      class: "h-full border dark:border-dark-400",
                                      value: _ctx.historySourceCodeList[history.judgeId]
                                    }, null, 8, ["value"])
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_IconTextButton, {
                                      border_radius: 2,
                                      class: "mx-1",
                                      font_weight: '700',
                                      icon: 'reviews',
                                      iconSize: 'text-xl',
                                      padding_bottom: 4,
                                      padding_left: 12,
                                      padding_right: 12,
                                      padding_top: 4,
                                      text: _ctx.$t('message.review'),
                                      textSize: 'text-base',
                                      onClick: ($event: any) => (_ctx.openReviewAlertModal(history.judgeId, history.status))
                                    }, null, 8, ["text", "onClick"]),
                                    _createVNode(_component_IconTextButton, {
                                      border_radius: 2,
                                      class: "mx-1",
                                      font_weight: '700',
                                      icon: 'content_copy',
                                      iconSize: 'text-xl',
                                      padding_bottom: 4,
                                      padding_left: 12,
                                      padding_right: 12,
                                      padding_top: 4,
                                      text: _ctx.$t('message.copy'),
                                      textSize: 'text-base',
                                      onClick: ($event: any) => (_ctx.copyClipboard(_ctx.historySourceCodeList[history.judgeId]))
                                    }, null, 8, ["text", "onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["isSummaryExpanded", "loading", "onClickSummary"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_ctx.sortedHistoryList.length <= 0 && !_ctx.historyListIsLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('message.noData')), 1))
            : _createCommentVNode("", true),
        (_ctx.historyListIsLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_LoadingPanel)
            ]))
          : (_ctx.historyListError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('message.error')), 1))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["click", "title"])
  ]))
}